import { Button, Modal, Spin } from 'antd';
import { cloneDeep, isArray } from 'lodash';
import React, { memo, useMemo, useState } from 'react';
import { MODULE_TYPES } from '../../../../common/constants';
import AuthorCarousel from '../../../component/authorModules/AuthorCarousel';
import AuthorGrid from '../../../component/authorModules/AuthorGrid';
import AuthorList from '../../../component/authorModules/AuthorList';
import CategoryCard from '../../../component/categoryModule/CategoryCard';
import TopicCarousel from '../../../component/categoryModule/CategoryCarousel';
import TopicGrid from '../../../component/categoryModule/CategoryGrid';
import TopicList from '../../../component/categoryModule/CategoryList';
import CollectionCarousel from '../../../component/collectionModule/CollectionCarousel';
import CollectionGrid from '../../../component/collectionModule/CollectionGrid';
import CollectionList from '../../../component/collectionModule/CollectionList';
import BannerImage from '../../../component/ctaModule/BannerImage';
import CtaCard from '../../../component/ctaModule/CtaCard';
import FeaturedCollection from '../../../component/featuredModules/FeaturedCollection';
import FeaturedCollectionCarousel from '../../../component/featuredModules/FeaturedCollectionCarousel';
import FeaturedSpeaker from '../../../component/featuredModules/FeaturedSpeaker';
import FeaturedCarousel from '../../../component/featuredModules/FeaturedVideoCarousel';
import TemplateLayout from '../../../component/layout/TemplateLayout';
import Contact from '../../../component/marketingComponent/contact/Contact';
import CtaBanner from '../../../component/marketingComponent/ctaModule/CtaBanner';
import CtaMarketingBlock from '../../../component/marketingComponent/ctaModule/CtaMarketingBlock';
import Donate from '../../../component/marketingComponent/donate/Donate';
import FaqModule from '../../../component/marketingComponent/faqModule/FaqModule';
import HeavyModule from '../../../component/marketingComponent/heavyModule/HeavyModule';
import HeroBlock from '../../../component/marketingComponent/heroModules/HeroBlock';
import InformationBlock from '../../../component/marketingComponent/informationModule/InformationBlock';
import NewsLetter from '../../../component/marketingComponent/newsLatter/NewsLetter';
import QuoteSlider from '../../../component/marketingComponent/quoteModule/QuoteSlider';
import SectionAdd from '../../../component/sectionWrapper/SectionAdd';
import SectionWrapper from '../../../component/sectionWrapper/SectionWrapper';
import TagCarousel from '../../../component/tagModules/TagCarousel';
import TagGrid from '../../../component/tagModules/TagGrid';
import TagHero from '../../../component/tagModules/TagHero';
import VideoCarousel from '../../../component/videoModule/VideoCarousel';
import VideoGrid from '../../../component/videoModule/VideoGrid';
import VideoInfo from '../../../component/videoModule/VideoInfo';
import VideoList from '../../../component/videoModule/VideoList';
import { FORM_TYPES, useEditPage } from '../../context/EditPageProvider';
import { usePagePreview } from '../../context/PreviewPageProvider';

const SettingButton = () => {
  const { setSelectionType, isAdding } = useEditPage();

  const handleClick = () => {
    if (isAdding) return;
    setSelectionType(MODULE_TYPES.SETTINGS);
  };

  return (
    <div className="section-add-wrapper">
      <div className="section-add-block">
        <Button disabled={isAdding} onClick={handleClick} type="text">
          <svg
            width="31"
            height="31"
            viewBox="0 0 31 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.7559 2.58301C14.4408 2.58301 14.1693 2.81159 14.1177 3.12288L13.7519 5.32528C13.1232 5.43335 12.5153 5.60044 11.9304 5.81722L10.5076 4.09163C10.3074 3.84751 9.95897 3.78391 9.68514 3.94279L8.39852 4.68701C8.12469 4.8446 8.00488 5.1771 8.11597 5.4716L8.89803 7.56047C8.4131 7.9646 7.96509 8.41261 7.56095 8.89754L5.47209 8.11548C5.17759 8.0044 4.84508 8.1242 4.6875 8.39803L3.94328 9.68465C3.7844 9.95849 3.848 10.3069 4.09212 10.5071L5.81771 11.9299C5.60093 12.5149 5.43384 13.1227 5.32577 13.7514L3.12337 14.1172C2.81208 14.1701 2.5835 14.439 2.5835 14.7555V16.2439C2.5835 16.5591 2.81208 16.8305 3.12337 16.8822L5.32577 17.248C5.43384 17.8767 5.60093 18.4845 5.81771 19.0694L4.09212 20.4923C3.848 20.6925 3.78569 21.0409 3.94328 21.3147L4.6875 22.6013C4.84508 22.8752 5.17759 22.995 5.47209 22.8839L7.56095 22.1018C7.96509 22.5867 8.4131 23.0347 8.89803 23.4389L8.11597 25.5278C8.00488 25.8235 8.12598 26.1548 8.39852 26.3123L9.68514 27.0566C9.95897 27.2141 10.3074 27.1505 10.5076 26.9077L11.9279 25.1821C12.5135 25.3993 13.1224 25.5659 13.7519 25.6741L14.1177 27.8765C14.1706 28.1878 14.4395 28.4163 14.7559 28.4163H16.2444C16.5596 28.4163 16.831 28.1878 16.8826 27.8765L17.2485 25.6741C17.8772 25.566 18.485 25.3989 19.0699 25.1821L20.4928 26.9077C20.693 27.1518 21.0414 27.2141 21.3152 27.0566L22.6018 26.3123C22.8756 26.1548 22.9954 25.8223 22.8844 25.5278L22.1023 23.4389C22.5872 23.0347 23.0352 22.5867 23.4394 22.1018L25.5282 22.8839C25.824 22.995 26.1552 22.8739 26.3128 22.6013L27.057 21.3147C27.2146 21.0409 27.151 20.6925 26.9082 20.4923L25.1826 19.0719C25.3998 18.4863 25.5664 17.8775 25.6746 17.248L27.877 16.8822C28.1882 16.8292 28.4168 16.5604 28.4168 16.2439V14.7555C28.4168 14.4403 28.1882 14.1689 27.877 14.1172L25.6746 13.7514C25.5665 13.1227 25.3994 12.5149 25.1826 11.9299L26.9082 10.5071C27.1523 10.3069 27.2146 9.95849 27.057 9.68465L26.3128 8.39803C26.1552 8.1242 25.8227 8.0044 25.5282 8.11548L23.4394 8.89754C23.0352 8.41261 22.5872 7.9646 22.1023 7.56047L22.8844 5.4716C22.9954 5.17581 22.8743 4.8446 22.6018 4.68701L21.3152 3.94279C21.0414 3.78521 20.693 3.8488 20.4928 4.09163L19.0724 5.81722C18.4868 5.60004 17.878 5.43349 17.2485 5.32528L16.8826 3.12288C16.8297 2.81159 16.5608 2.58301 16.2444 2.58301H14.7559ZM14.2085 7.86572V11.8669C12.7136 12.406 11.6252 13.8293 11.6252 15.4997C11.6252 15.7411 11.6526 15.9763 11.6958 16.2061L8.23958 18.2016C7.92819 17.3601 7.75016 16.4525 7.75016 15.4997C7.75016 11.6455 10.5342 8.47791 14.2085 7.86572ZM16.7918 7.86572C20.4662 8.47791 23.2502 11.6455 23.2502 15.4997C23.2502 16.4528 23.0698 17.3598 22.7582 18.2016L19.3045 16.2061C19.3477 15.9763 19.3752 15.7411 19.3752 15.4997C19.3752 13.8293 18.2867 12.406 16.7918 11.8669V7.86572ZM15.5002 14.208C16.2288 14.208 16.7918 14.771 16.7918 15.4997C16.7918 16.2283 16.2288 16.7913 15.5002 16.7913C14.7715 16.7913 14.2085 16.2283 14.2085 15.4997C14.2085 14.771 14.7715 14.208 15.5002 14.208ZM13.0051 18.4312C13.683 19.01 14.5482 19.3747 15.5002 19.3747C16.4521 19.3747 17.3173 19.01 17.9952 18.4312L21.4792 20.4418C20.0602 22.1595 17.9138 23.2497 15.5002 23.2497C13.0865 23.2497 10.9401 22.1595 9.52116 20.4418L13.0051 18.4312Z"
              fill="black"
            />
          </svg>
        </Button>
      </div>
    </div>
  );
};

const AddSection = memo(
  ({ index, setSelectionType, setAddIndex, isAdding, clearRightPanel }) => {
    const handleClick = () => {
      if (isAdding) return;
      clearRightPanel();
      setSelectionType(MODULE_TYPES.ADD);
      setAddIndex(index);
    };
    return <SectionAdd disabled={isAdding} onAdd={handleClick} />;
  }
);

const Div = (props) => <div {...props} />;

export const PlaceHolderComponents = {
  // Videos
  [MODULE_TYPES.VIDEO_CONTINUE_WATCHING_CAROUSEL]: VideoCarousel,
  [MODULE_TYPES.VIDEO_WATCH_LATER_CAROUSEL]: VideoCarousel,
  [MODULE_TYPES.VIDEO_CAROUSEL]: VideoCarousel,
  [MODULE_TYPES.VIDEO_LIST]: VideoList,
  [MODULE_TYPES.VIDEO_GRID]: VideoGrid,
  [MODULE_TYPES.FEATURED_VIDEO]: FeaturedCarousel,
  [MODULE_TYPES.FEATURED_VIDEO_SLIDER]: FeaturedCarousel,
  [MODULE_TYPES.VIDEO_PLAYER]: VideoInfo,
  // Collections
  [MODULE_TYPES.COLLECTION_CAROUSEL]: CollectionCarousel,
  [MODULE_TYPES.COLLECTION_GRID]: CollectionGrid,
  [MODULE_TYPES.COLLECTION_LIST]: CollectionList,
  [MODULE_TYPES.FEATURED_COLLECTION]: FeaturedCollection,
  [MODULE_TYPES.FEATURED_COLLECTION_SLIDER]: FeaturedCollectionCarousel,
  // Authors
  [MODULE_TYPES.AUTHOR_CAROUSEL]: AuthorCarousel,
  [MODULE_TYPES.AUTHOR_GRID]: AuthorGrid,
  [MODULE_TYPES.AUTHOR_LIST]: AuthorList,
  [MODULE_TYPES.FEATURED_AUTHOR]: FeaturedSpeaker,
  // Tags
  [MODULE_TYPES.TAG_CAROUSEL]: TagCarousel,
  [MODULE_TYPES.TAG_CLOUD]: TagGrid,
  [MODULE_TYPES.FEATURED_TAG]: TagHero,
  // Topics
  [MODULE_TYPES.TOPIC_CAROUSEL]: TopicCarousel,
  [MODULE_TYPES.TOPIC_LIST]: TopicList,
  [MODULE_TYPES.TOPIC_GRID]: TopicGrid,
  [MODULE_TYPES.FEATURED_TOPIC]: CategoryCard,
  // CTA
  [MODULE_TYPES.CTA_BLOCK]: CtaCard,
  [MODULE_TYPES.CTA_EVENT_BLOCK]: CtaMarketingBlock,
  [MODULE_TYPES.CTA_BANNER_WITH_TEXT]: CtaBanner,
  [MODULE_TYPES.CTA_BANNER]: BannerImage,
  [MODULE_TYPES.HERO]: HeroBlock,
  // Donation
  [MODULE_TYPES.DONATION]: Donate,
  // Copy Heavy
  [MODULE_TYPES.COPY_HEAVY]: HeavyModule,
  [MODULE_TYPES.COPY_HEAVY_HERO]: HeavyModule,
  // Quote
  [MODULE_TYPES.QUOTE]: QuoteSlider,
  // Information
  [MODULE_TYPES.INFORMATION]: InformationBlock,
  // Lead Gen
  [MODULE_TYPES.LEAD_GEN]: NewsLetter,
  // Contact Us
  [MODULE_TYPES.CONTACT_US]: Contact,
  // FAQs
  [MODULE_TYPES.FAQ]: FaqModule,
  // Spacer
  [MODULE_TYPES.SPACER]: Div
};

const getFilteredPlaceholderData = (placeholderData, keyBindings, settings) => {
  if (!keyBindings || !settings) return placeholderData;
  if (keyBindings === null || typeof keyBindings !== 'object')
    return placeholderData;

  const { data, responsive, ...rest } = placeholderData;
  const { headerKeys, dataKeys } = keyBindings;
  const newPlaceholderData = {
    responsive
  };
  if (headerKeys) {
    Object.entries(rest).forEach(([key, value]) => {
      if (!(key in headerKeys)) {
        newPlaceholderData[key] = value;
        return;
      }
      if (settings?.[headerKeys?.[key]]) newPlaceholderData[key] = value;
    });
  } else {
    Object.entries(rest).forEach(([key, value]) => {
      newPlaceholderData[key] = value;
    });
  }

  if (dataKeys) {
    if (isArray(data) && data.length > 0) {
      newPlaceholderData.data = data.map((obj) => {
        const newObj = {};
        Object.entries(obj).forEach(([key, value]) => {
          if (!(key in dataKeys)) {
            newObj[key] = value;
            return;
          }
          if (settings?.[dataKeys?.[key]]) newObj[key] = value;
        });
        return newObj;
      });
    }
  } else {
    newPlaceholderData.data = data;
  }

  return newPlaceholderData;
};

const Module = memo(
  ({
    data,
    index,
    lastIndex,
    deletePageModule,
    deleteModule,
    moveModule,
    setForm,
    setSelectionType,
    isAdding,
    isEditing,
    isMoving,
    refetch
  }) => {
    const [isDeleting, setIsDeleting] = useState(false);

    const handleMoveUp = () => {
      if (isAdding || isEditing) return;
      moveModule(index, Math.max(0, index - 1));
    };

    const handleMoveDown = () => {
      if (isAdding || isEditing) return;
      moveModule(index, Math.min(lastIndex, index + 1));
    };

    const handleMoveTop = () => {
      if (isAdding || isEditing) return;
      moveModule(index, 0);
    };

    const handleMoveBottom = () => {
      if (isAdding || isEditing) return;
      moveModule(index, lastIndex);
    };

    const handleDelete = () => {
      if (isAdding || isEditing || !data.moduleData || isDeleting) return;

      Modal.confirm({
        title: 'Are you sure, you want to delete this page module?',
        centered: true,
        okText: 'Yes',
        cancelText: 'No',
        okType: 'primary',
        onOk() {
          setIsDeleting(true);
          deletePageModule({ variables: { id: data.moduleData.id } })
            .then(() => {
              deleteModule(index);
              setIsDeleting(false);
              refetch();
            })
            .catch(() => {
              setIsDeleting(false);
            });
        }
      });
    };

    const handleEdit = () => {
      if (!data.moduleData) return;
      const { type } = data.moduleData;
      setForm({
        index,
        type: FORM_TYPES.EDIT,
        moduleId: data.moduleData.id,
        defaultValues: cloneDeep(data.moduleData)
      });
      setSelectionType(type);
    };

    const placeholderData = useMemo(
      () =>
        getFilteredPlaceholderData(
          data.placeholderData,
          data.keyBindings,
          data.moduleData?.moduleData?.settings || null
        ),
      [data]
    );

    const module = useMemo(() => {
      const Component = PlaceHolderComponents[data?.type];
      if (!Component) return null;

      return <Component {...placeholderData} />;
    }, [placeholderData]);

    if (!module) return null;

    return (
      <SectionWrapper
        isFirst={index === 0}
        isLast={index === lastIndex}
        onDelete={handleDelete}
        onMoveTop={handleMoveTop}
        onMoveUp={handleMoveUp}
        onMoveDown={handleMoveDown}
        onMoveBottom={handleMoveBottom}
        onEdit={handleEdit}
        showEdit={data.moduleData?.id}
        showDelete={data.moduleData?.id}
        disableEdit={isAdding}
        disableDelete={isAdding || isEditing || isDeleting}
        disableSort={isAdding || isEditing || isMoving}
        loadingDelete={isDeleting}
      >
        {module}
      </SectionWrapper>
    );
  }
);

const LeftPanel = () => {
  const {
    modules,
    fetchingPageDetails,
    deletePageModule,
    deleteModule,
    moveModule,
    setForm,
    setSelectionType,
    isAdding,
    isEditing,
    isMoving,
    setAddIndex,
    clearRightPanel
  } = useEditPage();

  const { refetch } = usePagePreview();
  const lastIndex = modules.length - 1;

  const moduleProps = useMemo(
    () => ({
      deletePageModule,
      deleteModule,
      moveModule,
      setForm,
      setSelectionType,
      isAdding,
      isEditing,
      isMoving,
      refetch
    }),
    [isAdding, isEditing, isMoving, moveModule]
  );

  const addSectionProps = useMemo(
    () => ({
      setSelectionType,
      setAddIndex,
      isAdding,
      clearRightPanel
    }),
    [isAdding]
  );

  return (
    <TemplateLayout>
      <SettingButton />
      <AddSection index={0} {...addSectionProps} />
      {fetchingPageDetails ? (
        <Spin className="mt-12 ml-4" />
      ) : (
        <>
          {modules.map((module, index) => (
            <React.Fragment key={module.id}>
              <Module
                data={module}
                index={index}
                lastIndex={lastIndex}
                {...moduleProps}
              />
              <AddSection index={index + 1} {...addSectionProps} />
            </React.Fragment>
          ))}
        </>
      )}
    </TemplateLayout>
  );
};

export default LeftPanel;
